export enum Disease {
  GENERAL_QUALITY = 'General_quality',
}